import styled from "styled-components";

export const ModalBody = styled.div`
  padding: 8px 4px 16px;
`;

export const ReceiptPaper = styled.div`
  background: #ffffff;
  color: #1a1a1a;
  padding: 24px 16px;
`;

export const ReceiptTitle = styled.h2`
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
`;

export const ReceiptStatus = styled.p<{ $failed: boolean }>`
  margin: 0 0 20px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ $failed }) => ($failed ? "#f9123b" : "#0eab44")};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;

  span:first-child {
    color: #6b6b6b;
  }

  span:last-child {
    text-align: right;
    font-weight: 500;
    word-break: break-word;
  }
`;

export const ErrorText = styled.p`
  margin: 16px 0;
  color: #f9123b;
  font-size: 14px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;
